import "../../assets/css/profile-buttons.css";
import { wrapAuthData } from "../AuthData/AuthData";
const shimmerProps = {height: "45px"};

export function ProfileButton(props) {
  const { children, handleClick=()=>{}, ctaUrl, icon=null, classList="", newTab=false } = props;
  const newTabAttr = newTab ? {
    target: "_blank",
    rel: "noopener noreferrer"
  } : "";

  const onClick = () => {
    if (typeof handleClick === "function") {
      handleClick(ctaUrl);
    }
  }

  return (
    <a className={`profile-button ${classList}`} onClick={onClick} href={ctaUrl ? ctaUrl : "#"} {...newTabAttr}>
      {icon}<span className="profile-button__content">{children}</span>
    </a>
  );
}

export default wrapAuthData(ProfileButton, {shimmerProps, name: "ProfileButton"});